// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608062037/js/" + chunkId + "." + {"44":"a4987108","225":"d57d38e8","481":"f7403315","486":"97737770","770":"2be099d4"}[chunkId] + ".0.4615278327191987.chunk.js";
};